import { withInstall } from "../utils/index.mjs";
import _Button from "./Button.mjs";
const Button = withInstall(_Button);
var stdin_default = Button;
import { buttonProps } from "./Button.mjs";
export {
  Button,
  buttonProps,
  stdin_default as default
};
